<template>
    <div class="cpg-display-container">
        <div class="cpg-generic-info">
            <p class="cpg-title"> {{campaign.labelHtml.toLowerCase().trim() | strippedContent}} </p>
            <div v-if="campaign.type == 'coupon'" class="cpg-coupon">
                <span class="info-text">{{kStrings.kINFO_CPN_CODE + ':'}}</span>
                <span class="coupon-code">{{campaign.couponId}}</span>
            </div>
        </div>
        <div class="cpg-detail">
            <p class="cpg-tile">{{kStrings.kDONT_FORGET}}</p>
            <p class="cpg-desc" v-html="campaign.phrase" />
            <div v-if="campaign.conditions && campaign.conditions.length" class="cpg-conditions">
                <span v-for="conditions in campaign.conditions " :key="conditions.couponRule">
                    <span v-html="conditions.couponRuleText"/>
                </span>
            </div>
        </div>    
        <div class="display-controls" :class="{'no-close' : campaign.type != 'coupon'}">
            <button class="cpg-btn" @click="close"> {{ kStrings.kCLOSE }} </button>
            <div v-if="campaign.type == 'coupon'" class="cpg-copy-btn">
                <CopyToClipboard v-if="campaign.type == 'coupon'" class="btn-clipboard" :btn-text="kStrings.kCOPY" :value="campaign.couponId" :kStrings="kStrings" />
            </div>
        </div>
    </div>
</template>
<script>

import CopyToClipboard from '@/components/Muffin/CopyToClipboard.vue';
import {storePdp} from '@/store/product-page';


export default {
    storePdp,
    name: 'CampaignDisplay',
    components: {
        CopyToClipboard,
    },
    props: {
        campaign: {
            type: Object,
            default: {}
        },
        kStrings: {
            type: Object,
            default: {}
        },
        stackedModal: { // for non block content modals, ex: pdp special price cpg modal open with others from blocks, etc
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            
        };
    },
    filters: {
        strippedContent: function(string) {
            return string ? string.replace(/<\/?[^>]+>/ig, " ") : '';
        }
    },
    created() {
    },
    beforeMount() {
    },
    methods: {
        close() {
            if(!this.stackedModal) {
                storePdp.dispatch('pdpDesktop/addToCartDesktop/updateShowPagePopup', '');
                this.$emit('select-tab', null);
            }
            this.$emit('close', null);
        },
    },
};
</script>

<style lang="scss">
    @import '../styles/ModalContent/campaignDisplay';
</style>
